(function () {
    'use strict';

    angular
        .module('app.user')
        .component('ubStepWizardPermissions', {
            bindings: {
                isEditMode: '<',
                applications: '<',
                userRoles: '<',
                existingPermissions: '<',
                existingRoles: '<',
                model: '<',
                userType: '<',
                onSave: '&',
                onApplicationAccessChanged: '&',
                onValidationChanged: '&'
            },
            controller: UserOnboardingStepWizardPermissions,
            controllerAs: 'vm',
            templateUrl: 'app/user/dashboard/onboard/wizard/step-permissions/user.onboard.wizard.permissions.html'
        });

    /* @ngInject */
    function UserOnboardingStepWizardPermissions($filter) {
        var vm = this;
        vm.$onInit = onInit;

        vm.getExistingRoles = getExistingRoles;
        vm.appExistsInExistingPermissions = appExistsInExistingPermissions;                
        vm.onApplicationPermissionsChanged = onApplicationPermissionsChanged;
        vm.onApplicationEdit = verifyApplicationEditStatus;
        vm.onApplicationSave = verifyApplicationEditStatus;
    
        function onInit() {
            vm.onApplicationAccessChanged();
        }
               
        function onApplicationPermissionsChanged(application) {           
            var appPerms = $filter('filter')(vm.model,
             { ApplicationId: application.ApplicationId }, true);
            if (appPerms.length > 0) {
                appPerms[0].HasAccess = application.HasAccess;
                appPerms[0].SelectedRoles = application.SelectedRoles;
            } else {
                vm.model.push(application);
            }
            vm.onApplicationAccessChanged();
        }

        function verifyApplicationEditStatus() {            
            var editedApps = _.where(vm.applications, { edited: true });

            var appsWithAccess = _.where(vm.applications, { access: true });
            if (appsWithAccess.length) {
                automaticallyAssignDefaultRoles(appsWithAccess);
            }          

            if (editedApps.length > 0) {
                vm.onValidationChanged({ isValid: false });
            } else {
                vm.onValidationChanged({ isValid: true });
            }            
        }

        function automaticallyAssignDefaultRoles(appsWithAccess) {
            angular.forEach(appsWithAccess, function (app) {
                if (!app.selectedRoles.length) {
                    if (vm.userType) {
                        var appFromDefaultApps = _.find(vm.userType.DefaultApplications,
                            { ApplicationId: app.ApplicationId });
                        if (appFromDefaultApps) {
                            angular.forEach(appFromDefaultApps.Roles, function (roleId) {
                                addRoleToApplication(app, roleId);
                            });                            
                        }                        
                    }
                    
                }
            });
        }

        function addRoleToApplication(app, roleId) {
            var matchingRole = _.find(app.Roles, { RoleId: roleId });
            if (matchingRole) {
                app.selectedRoles.push(matchingRole);
            }
        }
        

        function getExistingRoles(applicationId) {
            var application = $filter('filter')(vm.existingPermissions,
               { ApplicationId: applicationId }, true);
            if (application.length > 0) {
                return application[0].Roles;
            }
            return [];
        }

        function appExistsInExistingPermissions(applicationId) {
            var application = $filter('filter')(vm.existingPermissions,
                { ApplicationId: applicationId }, true);
            if (application.length > 0 && application[0].access) {
                return true;
            }
            return false;
        }           
    }
})();
